import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 14.624 12.376"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.5 0H1.124A1.125 1.125 0 0 0 0 1.126V11.25a1.125 1.125 0 0 0 1.124 1.126H13.5a1.125 1.125 0 0 0 1.124-1.126V1.126A1.125 1.125 0 0 0 13.5 0m0 1.126v2.25H1.124v-2.25zm0 10.124H1.124V4.5H13.5z"
    }, null, -1)
  ])))
}
export default { render: render }